import React, { Component } from 'react';
import { Helmet } from 'react-helmet'
import { connect } from 'react-redux'
import SimpleReactValidator from 'simple-react-validator';
import { updateUserInfo,getWebSessionId } from "../../actions/user";

import { getOrderInfo, saveOrderInfo, getStoreCreditInfo, segregateCart } from '../../actions/checkout'
import { clearCartInfo } from '../../actions/cart'
import { Link, withRouter } from 'react-router-dom'
import {  capillarySearchMember } from '../../actions/easyRewards';
import { toast } from 'react-toastify';


import Success from "./csa-success";

class checkOut extends Component {

    constructor() {
        super()
        this.validator = new SimpleReactValidator();
        this.state = {
            capillaryAddress : '',
            capPinCodeData : '',
            capCusumerData : ''
            
        }
    }

   async componentDidMount() {
         const data = {
               mobile_no: localStorage.getItem('mobile_no'),
               connection_id:this.props.connection_id
             };
             const {capillaryFlag} = this.props;
   let capData= [];
   let capilartyData = '';
   let capAddr = '';
   let capZip = '';
   if(capillaryFlag == 'Y') {
   capData = await this.props.capillarySearchMember(data);
     capilartyData = capData && capData.data && capData.data.data.length > 0 && capData.data.data[0].customer_details ? capData.data.data[0].customer_details : '';
        capAddr = capilartyData != '' && capilartyData.custom_fields ? capilartyData.custom_fields : '' ;
        capZip = capilartyData != '' && capilartyData.extended_fields ? capilartyData.extended_fields : '' ;
        
        this.setState({
            capillaryAddress : capAddr,
            capPinCodeData :capZip,
            capCusumerData : capilartyData
        })
   }
        const options = {
            connection_id: this.props.connection_id,
            web_session_trans_id: this.props.web_session_trans_id,
        }
        
document.querySelector("header").style.display='block'
        this.props.getOrderInfo(options)
        const { updateUserInfo, connection_id, userInfo, presentURL,  cartTotal } = this.props;
        const options1 = {
            connection_id,
            mobile_no: userInfo.COM_CONSUMER_MOBILE_NO
        }
        updateUserInfo(options1)
            const storeOptions = {
                connection_id,
                web_session_trans_id: this.props.web_session_trans_id,
                consumer_mobile_no: userInfo.COM_CONSUMER_MOBILE_NO,
                order_value: cartTotal,
                query_action: "REMOVE",
            }
            this.props.getStoreCreditInfo(storeOptions)
            const storeOptionsAfter = {
                connection_id,
                web_session_trans_id: this.props.web_session_trans_id,
                consumer_mobile_no: userInfo.COM_CONSUMER_MOBILE_NO,
                order_value: cartTotal,
                query_action: "GET",
            }
            setTimeout(() => {
                this.props.getStoreCreditInfo(storeOptionsAfter);
            }, 0)

    }

    setStateFromInput = (event) => {
        var obj = {};
        obj[event.target.name] = event.target.value;
        this.setState(obj);
    }

    setStateFromCheckbox = (event) => {
        var obj = {};
        obj[event.target.name] = event.target.checked;
        this.setState(obj);

        if (!this.validator.fieldValid(event.target.name)) {
            this.validator.showMessages();
        }
    }

    checkhandle(value) {
        this.setState({
            payment: value
        })
    }

    isShippingAddress() {
        const { userInfo } = this.props
        if (!userInfo.COM_ADDRESS1 || !userInfo.COM_PIN) return false
        return true
    }

    isBillingAddress() {
        const { userInfo } = this.props
        if (!userInfo.COM_BILL_TO_ADDRESS1 || !userInfo.COM_BILL_TO_PIN) return false
        return true
    }
    handleSaveOrder(info = {}) {
        const { userInfo, store_details, orderInfo, connection_id } = this.props

        const options = {
            connection_id: connection_id,
            consumer_mobile_no: userInfo.COM_CONSUMER_MOBILE_NO,
            consumer_name: userInfo.COM_FNAME,
            web_session_trans_id: this.props.web_session_trans_id,
        }
        if(this.props.capillaryFlag == "Y" ){
if (this.state.capPinCodeData != '' && ! this.state.capPinCodeData.zip){
    toast.error('Please update the address')
    return;
}
        }
        // const options = [{
        //     connection_id: connection_id,
        //     consumer_mobile_no: userInfo.COM_CONSUMER_MOBILE_NO,
        //     consumer_full_name: userInfo.COM_FNAME,
        //     web_session_trans_id: this.props.web_session_trans_id,
        //     delivery_mode: "H",
        //     payment_mode: "T",
        //     user_logged_in_store_id: store_details.store_code,
        //     booking_store_id: store_details.store_code,
        //     pickup_store_id:    store_details.store_code,
        //     cash_received: "",
        //     cash_return: "",
        //     cod_amount: this.props.storeCredit.AMOUNT_PAYABLE,
        //     order_type: orderInfo.RID_CART_ORDER_TYPE && orderInfo.RID_CART_ORDER_TYPE.toUpperCase(),
        //     order_value: orderInfo.RID_NET_AMT,
        //     delivery_address: {
        //         salutation: userInfo.COM_SALUTATION,
        //         first_name: userInfo.COM_FNAME,
        //         last_name: (userInfo.COM_LNAME === null ) ?  "" : userInfo.COM_LNAME,
        //         mobile_no: userInfo.COM_CONSUMER_MOBILE_NO,
        //         email_id: userInfo.COM_EMAIL_ID,
        //         address_1: userInfo.COM_ADDRESS1,
        //         address_2: userInfo.COM_ADDRESS2,
        //         address_3: userInfo.COM_ADDRESS3,
        //         city: userInfo.COM_TOWN_NAME,
        //         state_id: userInfo.COM_STATE_NAME,
        //         country_code: userInfo.COM_CONTRY_NAME,
        //         pin_code: userInfo.COM_PIN
        //     },
        //     billing_address: {
        //         email_id: userInfo.COM_BILL_TO_EMAIL_ID,
        //         address_1: userInfo.COM_BILL_TO_ADDRESS1,
        //         address_2: userInfo.COM_BILL_TO_ADDRESS2,
        //         address_3: userInfo.handleSaveOrderCOM_BILL_TO_ADDRESS3,
        //         city: userInfo.COM_BILL_TO_TOWN_NAME,
        //         state_id: userInfo.COM_BILL_TO_STATE_NAME,
        //         country_code: userInfo.COM_BILL_TO_CONTRY_NAME,
        //         pin_code: userInfo.COM_BILL_TO_PIN
        //     },
        //     tender_details : []
        // }]
        // this.props.saveOrderInfo(options)
        // this.setState({
        //     success1: true
        // })
localStorage.removeItem('mobile_no');
        this.props.segregateCart(options)
        this.props.getWebSessionId(connection_id)

    }

    render() {
        const {loading, userInfo, presentURL, success,profile_data,capillaryFlag,customer_name} = this.props 
        const {capillaryAddress,capPinCodeData,capCusumerData } =this.state;
        if (loading){
            return (
                <div>
                    <div className="product-wrapper-grid">
                        <div className="container-fluid">
                            <div className="loading-cls"></div>
                        </div>
                    </div>
                </div>
            )
        }

        if (!!success && profile_data === null) {
            // 
            return <>
                <Success message={'success'} {...this.props} />
            </>
        }
        return (
            <div style={{marginBottom:80}}>

                {/*SEO Support*/}
                <Helmet>
                <title>{this.props.customer_name}   | CheckOut Page</title>
                    <meta name="description" content="" />
                </Helmet>
                {/*SEO Support End */}
                <section className="m-0 p-0">
                    <div className="container">
                        <div className="row justify-content-center">
                            <div className="col-sm-12 col-lg-6" style={{ marginTop: "2%" }}>
                                <div className="custom-title">
                                    <span>Choose the Delivery Method</span>
                                </div>
                                <div className="mini-title-divider" style={{ marginBottom: 0 }}></div>
                                <div className="checkout-header">
                                    <div>
                                        <span>Home Delivery</span>
                                    </div>
                                    <div>
                                        <span></span>
                                    </div>
                                </div>
                                <div className="custom-divider" style={{ marginBottom: 0 }}></div>
                                <div>
                                    {this.isShippingAddress() ? (
                                        <div className="checkout-address-title">
                                            Shipping Address
                                            <div className="checkout-address">
                                                <div className="address">
                                                   <p>
  {capillaryFlag == 'Y' && capCusumerData
    ? `${capCusumerData.firstname || ''} ${capCusumerData.lastname|| ''}`
    : ` ${userInfo.COM_FNAME} ${userInfo.COM_LNAME}`}
</p>

<p>
  {capillaryFlag == 'Y' &&  capillaryAddress
    ? `${capillaryAddress.addressone || ''}, ${capillaryAddress.addresstwo || ''}, ${capillaryAddress.addressthree || ''}`
    : `${userInfo.COM_ADDRESS1}, ${userInfo.COM_ADDRESS2}, ${userInfo.COM_ADDRESS3}`}
</p>

<p>
  {capillaryFlag == 'Y' &&  capPinCodeData
    ? `${capPinCodeData.city || ''}, ${capPinCodeData.state || ''}, ${capPinCodeData.zip || ''}, ${capPinCodeData.country_of_residence|| ''}`
    : `${userInfo.COM_TOWN_NAME}, ${userInfo.COM_STATE_NAME} - ${userInfo.COM_PIN}, ${userInfo.COM_CONTRY_NAME}`}
</p> </div>
                                                <div className="edit-address" onClick={() => this.props.history.push('/profile/edit-address')}><span>Edit Address</span></div>
                                            </div>
                                        </div>
                                    ) :
                                        <div className="checkout-no-address"> <button className="btn btn-solid" style={{ padding: "10px 27px", }} onClick={() => this.props.history.push('/profile/edit-address')}>Add Shipping Address</button> </div>
                                    }
                                    <div className="custom-divider" style={{ marginBottom: 0 }}></div>
                                    {this.isBillingAddress() ? (
                                        <div className="checkout-address-title">
                                            Billing Address
                                            <div className="checkout-address">
                                                <div className="address">
                                                    <p>{capillaryFlag == 'Y' &&  capillaryAddress
    ? `${capillaryAddress.addressone || ''}, ${capillaryAddress.addresstwo || ''}, ${capillaryAddress.addressthree || ''}`
    : 
                                                    `${userInfo.COM_BILL_TO_ADDRESS1}, ${userInfo.COM_BILL_TO_ADDRESS2}, ${userInfo.COM_BILL_TO_ADDRESS3}`}</p>
                                                    <p> { capillaryFlag == 'Y' &&  capPinCodeData
    ? `${capPinCodeData.city || ''}, ${capPinCodeData.state || ''}, ${capPinCodeData.zip || ''}, ${capPinCodeData.country_of_residence|| ''}`
    : `${userInfo.COM_BILL_TO_TOWN_NAME}, ${userInfo.COM_BILL_TO_STATE_NAME}-${userInfo.COM_BILL_TO_PIN}, ${userInfo.COM_BILL_TO_CONTRY_NAME}`}</p>
                                                </div>
                                                <div className="edit-address" onClick={() => this.props.history.push('/profile/edit-address')}><span>Edit Address</span></div>
                                            </div>
                                        </div>
                                    ) :
                                        <div className="checkout-no-address"> <button className="btn btn-solid" style={{ padding: "10px 27px", }} onClick={() => this.props.history.push('/profile/edit-address')}>Add Billing Address</button> </div>
                                    }
                                </div>
                                <div className="payment-footer payment-buttons row" style={{paddingBottom:'10px'}}>
                                  { this.props.store_details.pay_here && this.props.store_details.pay_here === 'Y'  ? 
                              this.props.capillaryFlag != 'Y' ?
                              <div className='col-sm-3' style={{  padding:6}} >
 
                                  {(this.isShippingAddress() && this.isBillingAddress()) ?
                                                <Link to={'/payment'} className="btn-solid btn" style={{ width: "100%", padding: "12px 0px" }}> PAY HERE </Link>
                                                : ""

                                            }</div> : <div className='col-sm-3' style={{  padding:6}} >
 
                                  {(this.isShippingAddress() && this.isBillingAddress() && capPinCodeData.zip) ?
                                                <Link to={'/payment'} className="btn-solid btn" style={{ width: "100%", padding: "12px 0px" }}> PAY HERE </Link>
                                                : ""

                                            }</div>
                                            
                                            : '' }
                                    <div className='col-sm-6 ' style={{  padding:6 }}  onClick={(event) => this.handleSaveOrder(event)}>
                                      {(this.isShippingAddress() && this.isBillingAddress()) || localStorage.getItem('csa_storeFlag') == 'TS' && customer_name == 'PUMA' ?
                                        <button className="btn btn-solid" 
                                        disabled={this.props.successLoading}
                                        style={{ width: "100%", padding: "12px 0px",textTransform:'uppercase' }}>{this.props.successLoading ? "Loading" : "Transfer to Cash Counter"}</button> 
                                          : '' } 
                                    </div>
                                    <div className='col-sm-3' style={{ padding:6 ,textTransform:'uppercase' }}>
                                        <button className="new-btn new-btn-solid" style={{ width: "100%",padding:"12px 0px",textTransform:'uppercase' }}  onClick={() => this.props.history.goBack()}>Back</button>
                                    </div>
                                </div>    
                                
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        )
    }
}
const mapStateToProps = (state) => ({
    symbol: state.data.symbol,
    userInfo: state.user.user_details,
    connection_id: state.tenant.connection_id,
    orderInfo: state.checkout.orderInfo,
    cartItems: state.cart.cartItems,
    web_session_trans_id: state.user.web_session_trans_id,
    selectedStore: state.store.selectedStore,
    success: state.checkout.success,
    profile_data : state.checkout.profile_data,
    successLoading: state.checkout.successLoading,
    loading: state.checkout.loading,
    error: state.checkout.error,
    customer_name: state.tenant.tenant_details.STE_ECOM_BRAND_NAME || "",
    presentURL: state.tenant.presentURL,
    storeCredit: state.checkout.storeCredit,
    storeCreditLoading: state.checkout.storeCreditLoading,
    storeCreditError: state.checkout.storeCreditError,
    cartTotal: state.cart.cartTotal,
    store_details: state.tenant.store_details,
    segregateCartData: state.checkout.segregateCartData,
     capillaryFlag: state.tenant.tenant_details.capillary_flg || "N",
})

export default connect(
    mapStateToProps,
    { getOrderInfo, saveOrderInfo, clearCartInfo,getWebSessionId, updateUserInfo, getStoreCreditInfo, segregateCart,capillarySearchMember }
)(withRouter(checkOut))